export default "__VITE_ASSET__durWuzT9__"